var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCreatedBy01 = function SvgCreatedBy01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 33.28,
    y1: 173.98,
    x2: 169.79,
    y2: 22.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a70095"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M170.71,29.29C151.82,10.4,126.71,0,100,0S48.18,10.4,29.29,29.29C10.4,48.18,0,73.29,0,100s10.4,51.82,29.29,70.71c18.89,18.89,44,29.29,70.71,29.29s51.82-10.4,70.71-29.29c18.89-18.89,29.29-44,29.29-70.71s-10.4-51.82-29.29-70.71ZM43.4,167.69c3.3-28.41,27.73-50.35,56.6-50.35,15.22,0,29.53,5.93,40.3,16.69,9.09,9.1,14.83,20.97,16.31,33.65-15.34,12.84-35.08,20.59-56.6,20.59s-41.26-7.74-56.6-20.59ZM100,105.28c-16.75,0-30.37-13.63-30.37-30.37s13.63-30.37,30.37-30.37,30.37,13.62,30.37,30.37-13.63,30.37-30.37,30.37ZM166.69,157.79c-2.99-12.04-9.21-23.14-18.11-32.03-7.2-7.2-15.72-12.61-25.02-15.99,11.17-7.58,18.53-20.38,18.53-34.86,0-23.21-18.88-42.09-42.09-42.09s-42.09,18.88-42.09,42.09c0,14.49,7.36,27.29,18.54,34.87-8.55,3.12-16.46,7.93-23.27,14.27-9.86,9.18-16.7,20.88-19.88,33.73-13.44-15.5-21.59-35.7-21.59-57.78C11.72,51.32,51.32,11.72,100,11.72s88.28,39.6,88.28,88.28c0,22.08-8.15,42.29-21.59,57.79Z"
  })));
};
export default SvgCreatedBy01;